"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FRENGLISH_BACKEND_URL = void 0;
//export const FRENGLISH_BACKEND_URL = 'https://api.frenglish.ai'
exports.FRENGLISH_BACKEND_URL = 'http://localhost:3001';
